// Shortcut definitions for different firms
export const ShortcutsConfig = {
  // Base PowerPoint shortcuts that all firms use
  BASE_SHORTCUTS: {
    "ctrl,a": {
      action: "selectAllShapes",
      description: "Ctrl+A - Select All"
    },
    "alt,h,g,a,l": {
      action: "alignLeft",
      description: "Alt+H, G, A, L - Align Left"
    },
    "alt,h,g,a,r": {
      action: "alignRight", 
      description: "Alt+H, G, A, R - Align Right"
    },
    "alt,h,g,a,t": {
      action: "alignTop",
      description: "Alt+H, G, A, T - Align Top"
    },
    "alt,h,g,a,b": {
      action: "alignBottom",
      description: "Alt+H, G, A, B - Align Bottom"
    },
    "alt,h,g,a,c": {
      action: "alignCenterHorizontally",
      description: "Alt+H, G, A, C - Center Horizontally"
    },
    "alt,h,g,a,m": {
      action: "alignCenterVertically",
      description: "Alt+H, G, A, M - Center Vertically"
    },
    "alt,h,g,a,h": {
      action: "distributeHorizontally",
      description: "Alt+H, G, A, H - Distribute Horizontally"
    },
    "alt,h,g,a,v": {
      action: "distributeVertically",
      description: "Alt+H, G, A, V - Distribute Vertically"
    },
    "ctrl,shift,[": {
      action: "sendSelectionToBack",
      description: "Ctrl+Shift+[ - Send to Back"
    },
    "ctrl,shift,]": {
      action: "bringSelectionToFront",
      description: "Ctrl+Shift+] - Bring to Front"
    }
  },

  // Firm-specific shortcuts
  FIRM_SHORTCUTS: {
    BAIN: {
      "alt,b,r,a,p,i,d": {
        action: "applyRAPIDFramework",
        description: "Alt+B, R, A, P, I, D - Apply RAPID Framework"
      },
      "alt,b,v,c": {
        action: "applyValueChain",
        description: "Alt+B, V, C - Apply Value Chain Analysis"
      },
      "alt,b,s,w,o,t": {
        action: "applySWOTAnalysis",
        description: "Alt+B, S, W, O, T - Apply SWOT Analysis"
      },
      "alt,b,m,p,s": {
        action: "applyMasterPresentation",
        description: "Alt+B, M, P, S - Apply Master Presentation Structure"
      },
      "ctrl,shift,o": {
        action: "addSticker",
        description: "Ctrl+Shift+O - Add Sticker"
      },
      "ctrl,shift,a": {
        action: "addStatusSticker",
        description: "Ctrl+Shift+A - Add Status Sticker"
      },

      "ctrl,shift,b": {
        action: "addBainBullets",
        description: "Ctrl+Shift+B - Add Bain Bullets"
      },
      "ctrl,shift,h": {
        action: "addHeaders",
        description: "Ctrl+Shift+H - Add Headers"
      },


      "alt,x,s,h": {
        action: "standardizeHeights",
        description: "Alt+X, S, H - Standardize Heights"
      },
      "alt,x,s,w": {
        action: "standardizeWidths",
        description: "Alt+X, S, W - Standardize Widths"
      }
    },
    
    MCKINSEY: {
      "alt,m,7,s": {
        action: "apply7SFramework",
        description: "Alt+M, 7, S - Apply McKinsey 7-S Framework"
      },
      "alt,m,p,y,r,a,m,i,d": {
        action: "applyMintoPyramid",
        description: "Alt+M, P, Y, R, A, M, I, D - Apply Minto Pyramid"
      }
    },
    
    BCG: {
      "alt,b,c,g,m": {
        action: "applyBCGMatrix",
        description: "Alt+B, C, G, M - Apply BCG Growth-Share Matrix"
      },
      "alt,b,c,g,e": {
        action: "applyExperienceCurve",
        description: "Alt+B, C, G, E - Apply Experience Curve"
      }
    }
  }
};

export default ShortcutsConfig;




